function LeaveTeamConfirmModal({
	isDarkMode,
	teamName,
	onLeaveAndUpgrade,
	onClose,
}) {
	return (
		<div className="relative z-50">
			<div className="fixed inset-0 bg-gray-900/50 transition-opacity" />
			<div className="fixed inset-0 z-10 flex items-start justify-center pt-20 p-4">
				<div className="w-full max-w-md">
					<div className={`relative transform overflow-hidden rounded-lg px-6 pt-10 pb-6 text-left shadow-xl ${
						isDarkMode
							? 'bg-gray-800 outline outline-1 -outline-offset-1 outline-white/10'
							: 'bg-white'
					}`}>
						<div className="text-center">
							<svg
								className="mx-auto h-12 w-12 text-orange-400 mb-4"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
								/>
							</svg>
							<h3 className={`text-lg font-semibold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
								Leave Team to Upgrade
							</h3>
							<p className={`text-sm mb-6 ${isDarkMode ? 'text-gray-300' : 'text-gray-500'}`}>
								You are currently a member of{' '}
								<span className="font-semibold">
									{teamName}
								</span>
								. To purchase your own subscription, you must leave this
								team first.
							</p>
							<div className="flex gap-3 justify-center">
								<button
									onClick={onClose}
									className={`rounded-md px-6 py-2 text-sm font-semibold ${
										isDarkMode
											? 'bg-gray-700 text-white hover:bg-gray-600'
											: 'bg-gray-100 text-gray-700 hover:bg-gray-200'
									}`}
								>
									Cancel
								</button>
								<button
									onClick={onLeaveAndUpgrade}
									className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md transition-colors"
								>
									Leave Team & Upgrade
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default LeaveTeamConfirmModal
